// extracted by mini-css-extract-plugin
export default {"xcm-query-builder-container":"xcmAudienceSelector_xcm-query-builder-container__5Wzy7"};